// extracted by mini-css-extract-plugin
export default {"noteCard":"Note_noteCard__kYnIN","cardBody":"Note_cardBody__Fnlxt","cardText":"Note_cardText__0y7OX"};